import React from 'react'
import { Box, CircularProgress, Alert } from '@mui/material'
import { Section, ReportTable } from '../../report-shell'

const OrangeOpaskaLastDaySalon = ({ data, loading, error }) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    )
  }
  if (error) return <Alert severity="error">{error}</Alert>
  if (!data) return null

  const serviceLookup = {}
  for (const s of (data.by_salon_service || [])) serviceLookup[s.Nazwa] = s

  const rows = (data.by_salon || [])
    .filter(s => s.last_day > 0)
    .map((s, i) => {
      const svc = serviceLookup[s.name] || {}
      return {
        id: s.name || i,
        name: s.name,
        city: s.city,
        district: s.district,
        region: s.region,
        z_usluga: svc.z_usluga_last_day || 0,
        bez_uslugi: svc.bez_uslugi_last_day || 0,
        total: s.last_day,
      }
    })

  const columns = [
    { field: 'name',       header: 'Nazwa',     width: '1.4fr', minWidth: 180 },
    { field: 'city',       header: 'Miasto',    width: '125px' },
    { field: 'district',   header: 'Dystrykt',  width: '150px' },
    { field: 'region',     header: 'Region',    width: '130px' },
    { field: 'z_usluga',   header: 'Z usługą',  width: '110px', sales: true },
    { field: 'bez_uslugi', header: 'Bez usługi', width: '120px', sales: true },
    { field: 'total',      header: 'Total',     width: '90px',  sales: true },
  ]

  return (
    <Section
      title="Ostatni dzień — per salon"
      subtitle={`Salony ze sprzedażą w ostatnim dniu (${rows.length})`}
    >
      <ReportTable
        rows={rows}
        columns={columns}
        initialSort={{ field: 'total', dir: 'desc' }}
        pageSize={25}
        pageSizeOptions={[25, 50, 100]}
        density="compact"
      />
    </Section>
  )
}

export default OrangeOpaskaLastDaySalon
